<template>
  <div class="container">
    <div class="preloader" v-if="!countItems">
      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
    </div>
    <div class="main-wrapper">
      <h1 class="catalog-title">
        <span>Контроль отстройки</span>
      </h1>

      <div 
        class="catalog chess"
        :class="{spacer: index != 0}"
        v-for="(collection, index) in collectionList"
        :key="index">
        <h2>{{collection.title}}</h2>
        <a 
          href="#"
          class="chess__item"
          v-for="(collectionItem, collectionIndex) in collection.products"
          :key="collectionIndex"
          :id="'link' + collectionItem.id"
          @click.prevent="detail(collectionItem.id, collection.id)"
        >
          <span class="chess__num">{{ collectionIndex + 1 }}</span>
          <div
            class="chess__img"
            v-bind:style="{backgroundImage: 'url(' + collectionItem.previewPicture + ')'}">
          </div>
          <p class="chess__discription">
              {{ collectionItem.name }}
          </p>
        </a>
      </div>
    </div>
    <router-link
        tag="p"
        class="createOrder-btn"
        v-if="isCartNoEmpty"
        to="/manufacture-order"
        >Завершить
    </router-link>
  </div>
</template>
<script>
var VueScrollTo = require('vue-scrollto');
export default {
  data: () => ({
    collectionList: [],
    reportId: "",
    collectionName: "",
    dataLoaded: false,
    reportId: '',
    cetalogElementId: '' //Id элемента с которого был переход(для того, чтобы прокрутить каталог к нему)
  }),
  methods: {
    getProducts() {
      this.$store.dispatch('GET_CONTROL_CATALOG_LIST', this.reportId).then(response => {
       
        this.collectionList = response.data.data;
        // this.collectionList = test;

        this.$localStorageSet("currentCollection", response.data.data);
        this.dataLoaded = true;
      })
    },
    startComponent(){
      this.reportId = this.$localStorageGet('currentControlID');
      this.getProducts();

      // Блокируем кнопку назад в телефоне
      history.pushState(null, document.title, location.href);
      window.addEventListener('popstate', function (event){
        history.pushState(null, document.title, location.href);
      });
    },
    detail(productID, collectionID){
      this.$router.push('/control-detail/'+collectionID+'/'+productID)
    }
    
  },
  computed: {
    countItems: function () {
      return Object.keys(this.collectionList).length;
    },
    isCartNoEmpty: function () {
      //Показать кнопку оформить заказ если в корзине что-то есть
      let miniCart = this.$localStorageGet("miniCart");
      return Object.keys(miniCart.baskets).length == 0 ? false : true;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      from.params.element != undefined ? vm.cetalogElementId = from.params.element : vm.cetalogElementId = '';
    });
  },
  watch:{
    dataLoaded: function(val){
      if(val && this.cetalogElementId != ''){  //Если в каталог перешли с карточки товара, прокрутить страницу до нужного элемента
        setTimeout(()=>{
          VueScrollTo.scrollTo('#link' + this.cetalogElementId)
        }, 1)
      }
    }
  }, 
  created(){
    this.startComponent();
  }
};
</script>
<style lang="scss">
  .createOrder-btn{
    width: 100%;
    border: 1px solid black;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 5px;
    background: #000;
    color: #fff;
    max-width: 340px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
  h2{
      font-size: 12px;
      text-align: center;
      width: 100%;
      padding-bottom: 30px;
  }
  .spacer{
      border-top: 5px solid red;
      padding-top: 20px;
      margin-top: 50px;
  }
</style>